<div class="form-group">
  <label [innerHtml]="question?.question_copy || question?.email_version"></label>
  <div id="email-verify-form">
    <div class="form-group" [ngClass]="{'has-error': errorMessage}">
      <input
        type="email"
        [(ngModel)]="value"
        (ngModelChange)="onEmailChange()"
        required
        value=""
        [placeholder]="question?.question_prompt"
        class="form-control"
        id="emailAddress"
        name="emailAddress">
      </div>

      <div class="form-group mb-0" [ngClass]="{'has-error': errorMessage}">
        <input
          type="email"
          [(ngModel)]="verify"
          (ngModelChange)="emailExists()"
          required
          value=""
          placeholder="Confirm Email"
          
          class="form-control"
          id="verifyEmail"
          name="verifyEmail">
          @if (errorMessage) {
            <p class="form-control-error">
              <svg class="icon">
                <use xlink:href="#warning-filled"></use>
              </svg>
              {{ errorMessage }}
            </p>
          }
        </div>
      </div>
    </div>


